import { Fragment, useState, useEffect, useRef } from "react";
import { Card } from "react-bootstrap";
import CardFrame from "../layout/CardFrame";
import ProductItemCard from "../Home/ProductItemCard";
import DDLmeasurementSettings from "../Measurement/DDLmeasurementSettings";
import productServices from "../../services/productService";
import { NotificationManager } from "react-notifications";
import {
  assign_ProductItemWithChargeStore,
  pushAtBottom_ProductItemWithChargeStore,
  update_ProductItem_forEdit,
  update_MeasurementSettingDetails_forEdit,
} from "../../slice/orderSlice";
import { useSelector, useDispatch } from "react-redux";
import productSave from "../../Models/ProductSave";
import ModalForForms from "../Modals/ModalForForms";
import ProductAdd from "./ProductAdd";

const Product = () => {
  //*** Store */
  const dispatch = useDispatch();
  const { productItemAllWithChargeStore } = useSelector((state) => state.order);
  const [selectedProductItem_GUID, setSelectedProductItem_GUID] = useState("");

  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [titlePopup, settitlePopup] = useState("");
  const [showAddProductPopup, setShowAddProductPopup] = useState(false);
  const [isAccessry, setIsAccessry] = useState(false);
  const childSubmitButton = useRef(); // forwardRef(); // useRef(null);

  //********************** add product measurement *************** */

  const AddProductPopup = (IsAccessry) => {
    settitlePopup("ADD ITEM");
    setShowAddProductPopup(true);
    setIsUpdateMode(false);
    setSelectedProductItem_GUID("");
    setIsAccessry(IsAccessry);

    // ** set store value blank field
    // dispatch(update_MeasurementSettingDetails_forEdit({}));
    dispatch(update_ProductItem_forEdit({}));
  };

  // const editProduct = (selectedProductItem_GIUD) => {
  //   settitlePopup("EDIT ITEM");
  //   alert("selectedProductItemGIUD ,vv " + selectedProductItem_GIUD);
  //   setSelectedProductItem_GUID(selectedProductItem_GIUD);
  //   if (selectedProductItem_GIUD === 0) {
  //     NotificationManager.warning(
  //       "Please select a product item",
  //       "Warning",
  //       4000
  //     );
  //     return;
  //   }
  // };

  const edit_productItem = async (selectedProductItem_GIUD, isAccessory) => {
    alert(
      "Edit - edit_productItem => selectedProductItem_GIUD: " +
        selectedProductItem_GIUD +
        ",..---" +
        isAccessory
    );

    if (selectedProductItem_GIUD === 0) {
      NotificationManager.warning(
        "Please select a product item",
        "Warning",
        4000
      );
      return;
    }

    settitlePopup("EDIT ITEM");
    //*** get from Database setting... */
    let productItem_By_GUID = await productServices.getByGUID(
      selectedProductItem_GIUD
    );

    // if (productItem_By_GUID != null) {
    //   if (measurementSettingDetail_GUID.fieldType === 2) {
    //     measurementSettingDetail_GUID.fieldType = true;
    //   } else if (measurementSettingDetail_GUID.fieldType === 1) {
    //     measurementSettingDetail_GUID.fieldType = false;
    //   }
    // }

    dispatch(update_ProductItem_forEdit(productItem_By_GUID));

    // settitlePopup(
    //   ("Edit Measurement Attribute( " +
    //     props.lstMeasurementDetail[0]?.name +
    //     " )")
    // );
    // settitlePopup(..."");
    setShowAddProductPopup(true);
    setIsUpdateMode(true);
    setSelectedProductItem_GUID(selectedProductItem_GIUD);

    // props.edit_MeasurementSettingsDetailsFunc(guid, isExtendedNote);
  };

  const deleteProduct = (selectedProductItemGIUD) => {
    alert("selectedProductItemGIUD ,vv " + selectedProductItemGIUD);
    setSelectedProductItem_GUID(selectedProductItemGIUD);
    if (selectedProductItemGIUD === 0) {
      NotificationManager.warning(
        "Please select a product item",
        "Warning",
        4000
      );
      return;
    }
  };

  useEffect(() => {
    //1. is Item Product OR accessory
    // ?type=cat&name=oscar
    const params = new URLSearchParams(window.location.search);
    const type = params.get("type");

    // const [queryParameters] = useSearchParams();
    // const type = queryParameters.get("type");
    if (type === "accessory") {
      setIsAccessry(true);
    } else {
      setIsAccessry(false);
    }

    //2. get List
    fetchProductAll();
  }, []);

  //(a) Get all measurement settings by settings ID(item)
  const fetchProductAll = async () => {
    try {
      let productAll;
      if (isAccessry) {
        productAll = await productServices.getAllAccessoriesWithPrice();
      } else {
        productAll = await productServices.getAllProductWithMakingCharge();
      }

      console.log(
        "productAll : " +
          productAll.length +
          ",   " +
          JSON.stringify(productAll[0])
      );

      dispatch(assign_ProductItemWithChargeStore([]));
      dispatch(assign_ProductItemWithChargeStore(productAll));
    } catch (e) {
      console.error(e);
    }
  };

  const SaveProductToDB = async (values) => {
    console.log("Form data " + JSON.stringify(values));

    let objToSave = new productSave();
    objToSave.ProductItemID_GUID = selectedProductItem_GUID;
    objToSave.ProductCategoryID_GUID = "";
    objToSave.innerObj = values;
    console.log("objToSave :" + objToSave);
    //isAccessory
    objToSave.isAccesory = isAccessry;

    let result = await productServices.save(objToSave);
    //Update
    if (result != null) {
      // //(1)
      // setOrderDetailGUID_state(result.orderDetailID_GUID);
      // //(2)
      // dispatch(
      //   updateOrderDetailGUID_OrderItemDetailStore({
      //     indexNo: props.indexEntry,
      //     orderDetailID_GUID: result.orderDetailID_GUID,
      //   })
      // );

      //Notification
      NotificationManager.success(
        "Measurement Attribute Saved successfully",
        "Successful!",
        4000
      );
      console.log("result : " + JSON.stringify(result));
      //add at list
      // dispatch(assign_ProductItemWithChargeStore(productAll));
      const updatedObject = { ...result };
      updatedObject.chargeAmount = values.Price; //  "411";

      dispatch(pushAtBottom_ProductItemWithChargeStore(updatedObject));
    } else {
      //Notification
      NotificationManager.warning(
        "Measurement Attribute Saved Failed",
        "Failed!",
        4000
      );
      console.log("result : " + JSON.stringify(result));
    }
  };

  const submitFromModalParent = () => {
    //alert("now submit child");
    childSubmitButton.current.click();
    //this.refs.childComponent.getWrappedInstance().handleSubmit();
  };

  const isValidChildFormInputs = (values) => {
    // alert("isValidChildFormInputs at parent");
    console.log("isValidChildFormInputs value : " + values);
  };

  //********************** END add product measurement *************** */

  return (
    <Fragment>
      {/* ModalPopUp for customer add */}
      {showAddProductPopup && (
        <ModalForForms
          title={titlePopup} //"Add Measurement Attribute"
          setShowAddCustomerPopup={setShowAddProductPopup}
          submitFromModalParent={submitFromModalParent}
        >
          <ProductAdd
            isValidChildFormInputs={isValidChildFormInputs}
            AddProductItemToDB={SaveProductToDB}
            ref={childSubmitButton}
          />{" "}
        </ModalForForms>
      )}

      <div style={{ clear: "both" }}></div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card" style={{ marginTop: "10px" }}>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="card-title"
                    style={{ marginBottom: "0px", height: "20px" }}
                  >
                    <div style={{ float: "left" }}>
                      {" "}
                      <h4>Product</h4>
                    </div>
                    <div style={{ float: "right" }}>
                      <button
                        onClick={() => AddProductPopup(false)}
                        className="btn btn-primary px-3"
                      >
                        Add New
                      </button>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <hr />
                    <div style={{ clear: "both" }}></div>
                  </div>
                  <br /> <br />
                  {/* List Table */}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>SI</th>
                          <th>Name</th> <th>Description</th>
                          <th>Making Charge</th>
                          <th>Is Accesory</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {productItemAllWithChargeStore
                          //.filter((o) => o.orderID_GUID === orderGUID)
                          .map((productItem, i) => {
                            return (
                              <tr>
                                <th>{i + 1}</th>
                                <td>{productItem.name}</td>
                                <td>{productItem.description}</td>
                                <td>{productItem.chargeAmount}</td>
                                <td>{productItem.isAccesory ? "Yes" : "NO"}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      edit_productItem(
                                        productItem.productItemID_GUID,
                                        false
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-light"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  &nbsp;
                                  <button
                                    onClick={() => {
                                      deleteProduct(
                                        productItem.productItemID_GUID
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-light"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Product;
